/* ZCRAVE nav scramble — ported from goya-child/assets/js/zcv-nav-brackets.js
   Letters cycle and lock left to right on hover. Timings kept identical. */
(function () {
  'use strict';
  if (window.__zcvScrambleInited) return;
  window.__zcvScrambleInited = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const POOL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*';
  const FRAME_MS = 50;         // ms per scramble step
  const FRAMES_PER_LETTER = 4; // cycles before the first letter locks
  const STAGGER = 2;           // frames between sequential locks
  // One scramble for the whole house: the top menu, the footer columns and the
// press page. Hila's ruling 2026-09-09 - the footer moves like the header.
const SELECTOR = '.z-nav__link, .z-sub a, .z-mega__list a, .zf__list a, .zpa__outlet, .zpa__read span';

  const rand = () => POOL.charAt(Math.floor(Math.random() * POOL.length));

  function scramble(el) {
    if (el._zcvTimer) clearInterval(el._zcvTimer);
    const target = el.dataset.zcvText || el.textContent.trim();
    el.dataset.zcvText = target;
    const chars = target.split('');
    const total = chars.length * STAGGER + FRAMES_PER_LETTER;
    let frame = 0;
    el._zcvTimer = setInterval(() => {
      let out = '';
      for (let i = 0; i < chars.length; i++) {
        if (chars[i] === ' ') { out += ' '; continue; }
        out += frame >= i * STAGGER + FRAMES_PER_LETTER ? chars[i] : rand();
      }
      el.textContent = out;
      if (frame >= total) {
        el.textContent = target;
        clearInterval(el._zcvTimer);
        el._zcvTimer = null;
        return;
      }
      frame++;
    }, FRAME_MS);
  }

  function reset(el) {
    if (el._zcvTimer) { clearInterval(el._zcvTimer); el._zcvTimer = null; }
    if (el.dataset.zcvText) el.textContent = el.dataset.zcvText;
  }

  document.addEventListener('mouseenter', (e) => {
    const a = e.target.closest && e.target.closest(SELECTOR);
    if (a) scramble(a);
  }, true);
  document.addEventListener('focusin', (e) => {
    const a = e.target.closest && e.target.closest(SELECTOR);
    if (a) scramble(a);
  });
  document.addEventListener('mouseleave', (e) => {
    const a = e.target.closest && e.target.closest(SELECTOR);
    if (a) reset(a);
  }, true);
})();
